export const environment = {
  production: false,
  apiUrl: 'https://api-managment-digitalizcija.azure-api.net/isbp-development/',
  keycloak: {
    clientId: 'isbp-employees-sunbeds',
    realm: 'isbp-test',
    url: ' https://wa-euwe-keycloak-test-01.azurewebsites.net/',
    logoutUrl: 'https://nice-moss-09a57ed03.6.azurestaticapps.net/logout',
  },
  useApim: true,
  secret: '4832f02c7fcd44658fecdc7cbbce42be',
};
